import { LAYOUT_CONSTANTS } from "@src/constants";
import { styled } from "@uhg-abyss/web/tools/styled";
import type { FC, ReactNode } from "react";

const DEFAULT_PAGE_BACKGROUND = "$app.color.default.background";

interface PageLayoutProps {
  children: ReactNode;
  backgroundColor?: string;
  css?: any;
}

const PageLayoutContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  height: "auto !important",
  paddingTop: "$core.spacing.500",
  position: "relative",
  paddingBottom: "$core.spacing.600",
  zIndex: 1,
  margin: "0 auto",
});

export const PageLayout: FC<PageLayoutProps> = ({
  children,
  backgroundColor = "$app.color.default.background",
  css,
}) => {
  return (
    <PageLayoutContainer
      data-testid="test-id-common-page-layout-content"
      css={{
        width: "100%",
        maxWidth: LAYOUT_CONSTANTS.maxPageWidth,
        backgroundColor: backgroundColor || DEFAULT_PAGE_BACKGROUND,
        ...css,
      }}
    >
      {children}
    </PageLayoutContainer>
  );
};
